// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-height: 800px) {\n.btn-print-result[data-v-7b571828] {\n        font-size: 14px;\n}\n}\n@media screen and (min-height: 800px) {\n.btn-print-result[data-v-7b571828] {\n        font-size: 16px;\n}\n}\n.btn-print-result[data-v-7b571828] {\n    padding: 10px 25px 8px 25px;\n}\n", ""]);
// Exports
module.exports = exports;
